var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.353 6.112a3.294 3.294 0 1 1-6.588 0 3.294 3.294 0 0 1 6.588 0ZM17.994 21.18c-.757.04-1.201-.956-.935-1.665.228-.608.353-1.306.353-2.108 0-1.215-.349-2.38-.977-3.397-.741-1.2-1.112-1.8-1.026-2.176a.919.919 0 0 1 .338-.532c.304-.237.757-.185 1.665-.081a8.23 8.23 0 0 1 3.73 1.396A6.595 6.595 0 0 1 24 18.052v.19c0 1.174-.783 2.216-1.935 2.442-1.33.26-2.696.426-4.07.496ZM2.859 12.618A6.595 6.595 0 0 0 0 18.052v.19c0 1.174.786 2.2 1.942 2.409 1.386.25 3.389.52 5.587.52 2.2 0 4.202-.27 5.588-.52 1.156-.21 1.942-1.235 1.942-2.409v-.19a6.595 6.595 0 0 0-2.859-5.434 8.244 8.244 0 0 0-9.341 0ZM16.47 9.407a3.294 3.294 0 1 0 0-6.589 3.294 3.294 0 0 0 0 6.589Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers24);
export default __webpack_public_path__ + "static/media/users_24.4d4a2235.svg";
export { ForwardRef as ReactComponent };